const _version = "3.5.2"
function version() {
    return _version
}
export default version
